import React from 'react';

/**
 * Radio button atom.
 */
export default function Radio({
  checked = false,
  onChange,
  name,
  value,
  'aria-label': ariaLabel,
  className = '',
}) {
  return (
    <label className={`ca-radio ${className}`.trim()}>
      <input
        type="radio"
        className="ca-radio__input"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        aria-label={ariaLabel}
      />
      <span className="ca-radio__mark" />
    </label>
  );
}
